import {
  CircleEmptyQuestionIcon,
  CloseIcon,
  IndicatorLabel,
  PendingIcon,
  Spinner,
} from "@codat/orchard-ui";
import classNames from "classnames";
import React from "react";

import styles from "./PullHistory.module.scss";

export const StateIndicatorLabel: React.FC<{ state: string }> = ({ state }) => {
  switch (state) {
    case "Complete":
      return <IndicatorLabel label={state} color="positive" />;
    case "Queued":
    case "MapQueued":
    case "ProcessingQueued":
    case "ValidationQueued":
      return (
        <IndicatorLabel
          label={state}
          color="neutral"
          leftIcon={<PendingIcon data-testid="queued-icon" />}
        />
      );
    case "Fetching":
    case "Mapping":
    case "Processing":
    case "Validating":
      return (
        <IndicatorLabel
          label={state}
          leftIcon={
            <Spinner
              className={classNames(styles.spinnerIcon)}
              data-testid="spinner-icon"
            />
          }
        />
      );
    case "FetchError":
    case "MapError":
    case "InternalError":
    case "ProcessingError":
    case "ValidationError":
    case "AuthError":
    case "RateLimitError":
    case "PermissionsError":
    case "PrerequisiteNotMet":
      return <IndicatorLabel label={state} color="negative" />;
    case "Cancelled":
      return (
        <IndicatorLabel
          label={state}
          color="warning"
          leftIcon={<CloseIcon data-testid="cancelled-icon" />}
        />
      );
    case "NotSupported":
      return (
        <IndicatorLabel
          label={state}
          color="warning"
          leftIcon={<CircleEmptyQuestionIcon data-testid="notsupported-icon" />}
        />
      );
    default:
      return <IndicatorLabel label={state} />;
  }
};
